module.exports = __webpack_public_path__ + "static/media/correct2.b6909fec.svg";